<div class="container">
    <div class="row justify-content-end">
        <button
            class="filter-btn-toggler"
            nbButton
            status="control"
            shape="semi-round"
            size="small"
            (click)="openModal(content)"
        >
            {{ "GENERAL.FILTER" | translate }} <nb-icon icon="funnel-outline"></nb-icon>
        </button>
    </div>
</div>

<ng-template #content let-modal>
    <nb-card class="filter-modal">
        <nb-card-body>
            <div class="modal-header d-flex align-items-center px-0 mb-4">
                <span class="subtitle">{{ "GENERAL.FILTER" | translate }}</span>
                <button type="button" nbButton tabindex="-1" (click)="closeModal()">
                    <nb-icon icon="close-outline"></nb-icon>
                </button>
            </div>
            <div class="modal-body">
                <div class="filter-options" *ngFor="let filter of filterList; let index = index">
                    <div
                        class="filter-options-header"
                        [class.list-active]="!collapse[index]"
                        (click)="collapse[index] = !collapse[index]"
                    >
                        <div>
                            <fa-icon [icon]="icons.caretRight"></fa-icon>
                            <span>{{ filter.label }}</span>
                        </div>

                    </div>
                    <div class="filter-options-list" [ngbCollapse]="collapse[index]">
                        <!-- prettier-ignore -->
                        <div
                    [ngClass]="['filter-option', filter.type === 1 ? 'radio' : 'checkbox']"
                    *ngFor="let option of filter.options; let index = index">
                    <input
                        [type]="filter.type === 1 ? 'radio' : 'checkbox'"
                        [attr.name]="'check-' + option.value"
                        [attr.data-filter]="filter.id"
                        [checked]="option.selected"
                        [id]="'check-' + option.value + index"
                        [value]="option.value"
                        (change)="onChangeEvt($event)"
                    />
                    <!-- prettier-ignore -->
                    <label [for]="'check-' + option.value + index">
                        <span>{{ option.label }}</span>
                        <fa-icon [icon]="icons.check" *ngIf="filter.type === 2"></fa-icon>
                    </label>
                </div>
                    </div>
                </div>
            </div>
        </nb-card-body>
        <nb-card-footer>
            <button nbButton fullWidth (click)="onFilterBtnClick()" class="mt-4">
                {{ "GENERAL.FILTER-RESULT" | translate }}
            </button>
        </nb-card-footer>
    </nb-card>
</ng-template>
